import { render, staticRenderFns } from "./pm-info.vue?vue&type=template&id=0c2d1a48&scoped=true"
import script from "./pm-info.vue?vue&type=script&lang=js"
export * from "./pm-info.vue?vue&type=script&lang=js"
import style0 from "./pm-info.vue?vue&type=style&index=0&id=0c2d1a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d1a48",
  null
  
)

export default component.exports